import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ListingPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ListingPageContainer" */
      './ListingPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
